import {
  AdvancedMarker,
  APIProvider,
  Map as GMap,
} from "@vis.gl/react-google-maps";

import publicConfig from "@/config/public";
import { mapStyles } from "@/utils/dispensary/mapStyleConfigs";

type MapProps = {
  location: {
    lon: number;
    lat: number;
  };
};

const Map = ({ location }: MapProps) => {
  const { lat, lon: lng } = location;

  return (
    <APIProvider apiKey={publicConfig.googleMapsApiKey} libraries={["places"]}>
      <GMap
        mapId={publicConfig.storeLocatorMapId}
        center={{ lat, lng }}
        zoom={14}
        disableDefaultUI
        gestureHandling="none"
        clickableIcons={false}
        disableDoubleClickZoom
        keyboardShortcuts={false}
        scrollwheel={false}
        styles={mapStyles}
      >
        <AdvancedMarker position={{ lat, lng }}>
          <div className="map-marker map-marker--md !left-0 !top-0" />
        </AdvancedMarker>
      </GMap>
    </APIProvider>
  );
};
export default Map;
